// デイトピッカー（プラグイン）管理
import commonClass from "./commonClass";

export default class datePickerClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._baseSetting = {
      showOn: 'both',
      buttonText: '',
      dateFormat: 'yy/mm/dd',
    }
    this._$tgt = $('.js-datepicker');
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    cls._$tgt.datepicker(cls._baseSetting).next('.ui-datepicker-trigger').addClass('c-btn_datepick');
  }

}